import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { RECENT_EVENTS } from '../../Assets/data/common';
import banner from '../../Assets/img/Events/event_banner.jpg'
import Footer from '../Footer';
import PublicHeader from '../Header/PublicHeader';
import { Link, useNavigate } from 'react-router-dom';

const EventDetails = () => {
  const { eventId } = useParams();
  const event = RECENT_EVENTS.find(event => event.id === eventId);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();

  if (!event) {
    return <div>Event not found</div>;
  }

  const nextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === (event.galleryImages?.length - 1) ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? (event.galleryImages?.length - 1) : prev - 1
    );
  };

  return (
    <>
      <PublicHeader />
      <div className="min-h-screen">
        <div className="w-full h-[30vh] sm:h-[40vh] relative mb-4 sm:mb-8">
          <img 
            src={banner}
            alt="Event Banner" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d73b9]/80 to-black/50 flex items-center justify-center">
            <h1 className="text-2xl sm:text-4xl font-bold text-white">Events</h1>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row px-4 sm:px-8 lg:pr-12 gap-8">
        
          <div className="w-full lg:w-[70%] h-[40vh] sm:h-[60vh] lg:h-[80vh] lg:pl-12 relative">
            {event.galleryImages ? (
              <>
                <TransitionGroup>
                  <CSSTransition
                    key={currentImageIndex}
                    timeout={300}
                    classNames="fade"
                  >
                    <img 
                      src={event.galleryImages[currentImageIndex]} 
                      alt={`${event.title} - Image ${currentImageIndex + 1}`} 
                      className="w-full h-full object-cover object-center rounded-lg absolute top-0 left-0"
                    />
                  </CSSTransition>
                </TransitionGroup>
                {event.galleryImages.length > 1 && (
                  <>
                    <button 
                      onClick={prevImage}
                      className="absolute left-1 sm:left-5 lg:left-5 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-200 focus:outline-none border border-gray-200"
                      aria-label="Previous image"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-7 sm:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                    <button 
                      onClick={nextImage}
                      className="absolute right-8 sm:right-10 lg:right-5 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full shadow-lg transition-all duration-200 focus:outline-none border border-gray-200"
                      aria-label="Next image"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-7 sm:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                    {/* Image Indicators */}
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                      {event.galleryImages.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentImageIndex(index)}
                          className={`w-2 h-2 rounded-full transition-colors ${
                            currentImageIndex === index ? 'bg-white' : 'bg-white/50'
                          }`}
                        />
                      ))}
                    </div>
                  </>
                )}
              </>
            ) : (
              <img 
                src={event.image} 
                alt={event.title} 
                className="w-full h-full object-cover object-center rounded-lg"
              />
            )}
          </div>

          <div className="w-full lg:w-[25%] bg-gray-50 min-h-[auto] lg:h-[80vh]">
            <div className="p-4 sm:p-6 pt-8">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 mt-4">{event.title}</h1>
              
              <div className="flex items-center text-gray-600 mb-4">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span className="text-base">{event.date}</span>
              </div>

              <div className="flex items-center text-gray-600 mb-6">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span className="text-base">{event.attendees} attendees</span>
              </div>

              <div className="flex items-center text-gray-600 mb-6">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <span className="text-base">
                  Organized by <span className="font-semibold text-[#0d73b9]">{event.organizer}</span>
                </span>

              </div>
              <div className="flex justify-between mt-6">
          {/* About More Button */}
          {event.aboutMore && (
  <Link 
    to={event.aboutMore.path}
    target="_blank" 
    rel="noopener noreferrer"
    className="bg-[#0d73b9] hover:bg-blue-500 text-white py-2 px-4 rounded-lg transition duration-300"
  >
    {event.aboutMore.label}
  </Link>
)}

          
        </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[66%] px-4 sm:px-8 lg:pl-24 py-8 flex flex-col sm:flex-row gap-6 sm:gap-0 sm:justify-between border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="p-3 sm:p-4 bg-blue-50 rounded-full">
              <svg className="w-6 h-6 sm:w-7 sm:h-7 text-[#0d73b9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <p className="text-sm sm:text-base text-gray-500">Event Date</p>
              <p className="text-base sm:text-lg font-medium text-gray-900">{event.date}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="p-3 sm:p-4 bg-blue-50 rounded-full">
              <svg className="w-6 h-6 sm:w-7 sm:h-7 text-[#0d73b9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <p className="text-sm sm:text-base text-gray-500">Event Time</p>
              <p className="text-base sm:text-lg font-medium text-gray-900">{event.time || "10:00 AM"}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="p-3 sm:p-4 bg-blue-50 rounded-full">
              <svg className="w-6 h-6 sm:w-7 sm:h-7 text-[#0d73b9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <p className="text-sm sm:text-base text-gray-500">Location</p>
              <p className="text-base sm:text-lg font-medium text-gray-900">{event.location}</p>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[90%] px-4 sm:px-8 lg:pl-24 py-8 sm:py-12">
          <div className="mb-8">
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">About Event</h2>
            <p className="text-gray-600 leading-relaxed">{event.description}</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">Event Details</h2>
            <ul className="list-disc pl-5 mt-2">
            {event.details.map((point, index) => (
              <li key={index} className="mb-1">{point}</li>
            ))}
          </ul>
          </div>
          {/* Join Us Button */}
          <button
            onClick={() => navigate(`/membership/plans`)}
            className="bg-[#0d73b9] hover:bg-blue-500 text-white mt-3 py-2 px-4 rounded-lg transition duration-300"
          >
            Join Us
          </button>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default EventDetails;
